import { ClassConstructor, plainToClass } from 'class-transformer';
import deepMerge from '../../Util/deepMerge';
import clone from '../../Util/clone';

class ConfigService<C> {
  private cachedConfig: C;

  constructor(private configModel: ClassConstructor<C>, defaultConfig: C) {
    this.cachedConfig = defaultConfig;
  }

  public mergeIntoConfig(partialConfig: Partial<C>): void {
    this.cachedConfig = deepMerge<C>(this.configModel, this.cachedConfig, partialConfig);
  }

  public get(): C {
    return plainToClass(this.configModel, clone(this.cachedConfig)) as C;
  }
}
export default ConfigService;
